/*
 * bb-accordion.js — single-open accordions.
 *
 * When a <details name="X"> opens, close any other open <details name="X"> in
 * the document, so a group of accordions only ever has one panel open at a time.
 *
 * Grouping is by the `name` attribute, which is set ONLY on the intentionally
 * grouped content accordions (the PDP info tabs and the FAQ / collapsible-content
 * rows), each scoped per section. Header menus, the cart drawer, facets, the
 * share button and the PDP "Complete the routine" cross-sell use their own
 * <details> with no `name`, so they are left completely untouched.
 *
 * Modern browsers already enforce this natively for <details name>; this is the
 * cross-browser fallback (older Safari/Firefox/Chrome) that keeps the behaviour
 * consistent everywhere. The `toggle` event does not bubble, so we listen in the
 * capture phase at the document. Idempotent + theme-editor safe (no per-element
 * state, one document-level listener).
 */
(function () {
  if (window.__bbAccordionInit) return;
  window.__bbAccordionInit = true;

  document.addEventListener(
    'toggle',
    function (e) {
      var el = e.target;
      if (!(el instanceof HTMLDetailsElement) || !el.open) return;
      var name = el.getAttribute('name');
      if (!name) return;
      var key = window.CSS && CSS.escape ? CSS.escape(name) : name;
      var group = document.querySelectorAll('details[name="' + key + '"]');
      for (var i = 0; i < group.length; i++) {
        if (group[i] !== el && group[i].open) group[i].open = false;
      }
    },
    true // capture: the toggle event does not bubble
  );
})();
